import { type WorkspaceAgentMessagePill } from '~/components/v2/components/workspace/workspace-agent-panel/schemas/pillMetadata';
import { type WorkspaceAgentTableRow } from '~/components/v2/components/workspace/workspace-agent-panel/schemas/workspaceAgentTableArtifact';
import { synthesizeWorkspaceAgentPillsFromContent } from '~/components/v2/components/workspace/workspace-agent-panel/utils/synthesizeWorkspaceAgentPillsFromContent';

const tablePagePillIdentity = (pill: WorkspaceAgentMessagePill): string => {
  if (pill.type === 'asset') {
    return `asset:${pill.assetId}:${pill.versionId ?? ''}`;
  }

  return `${pill.type}:${pill.id}`;
};

/**
 * Pills named by the rows on screen. The table's clip batch is this list, not the loaded artifact
 * and not the thread.
 */
export const collectWorkspaceAgentTablePagePills = (
  rows: readonly WorkspaceAgentTableRow[],
): readonly WorkspaceAgentMessagePill[] => {
  const pills: WorkspaceAgentMessagePill[] = [];
  const seen = new Set<string>();

  for (const row of rows) {
    for (const cell of Object.values(row)) {
      if (typeof cell !== 'string' || cell.length === 0) {
        continue;
      }

      for (const pill of synthesizeWorkspaceAgentPillsFromContent(cell)) {
        const identity = tablePagePillIdentity(pill);

        if (seen.has(identity)) {
          continue;
        }

        seen.add(identity);
        pills.push(pill);
      }
    }
  }

  return pills;
};
